import React, { ReactElement } from 'react'
import styled from '@emotion/styled'
import { ReactComponent as CrossIcon } from '../../../assets/icons/app/cross.icon.svg'

const TagStyle = styled.div<{
  customColor?: string
  disableRemoveButton?: boolean
}>`
  font-family: 'Fira Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f7f7f7;
  background: ${(props) =>
    props.customColor ? props.customColor : '#59595999'};
  border: 1px solid ${(props) => props.customColor || '#595959'};
  border-radius: 24px;
  padding: 4px 8px;
  gap: 4px;
  cursor: ${({ disableRemoveButton }) =>
    disableRemoveButton ? 'default' : 'pointer'};
`

const DeleteButtonStyle = styled.button<{ customColor?: string }>`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  /* identical to box height */

  display: flex;
  align-items: flex-end;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 2px;
  &:hover:not(.parentElement) {
    border: 1px solid ${(props) => props.customColor || '#595959'};
    background: ${(props) =>
      props.customColor ? props.customColor : '#595959b3'};
    filter: ${(props) => props.customColor && 'brightness(150%)'};
  }

  &:active:not(.parentElement) {
    border: 1px solid ${(props) => props.customColor || '#595959'};
    background: ${(props) =>
      props.customColor ? props.customColor : '#59595980'};
    filter: ${(props) => props.customColor && 'brightness(200%)'};
  }
`

interface Props {
  label: string
  icon: ReactElement
  handleRemoveItemFilter: () => void
  disableRemoveButton?: boolean
  children?: ReactElement
  color?: string
}

const GlFilterButtonV2 = ({
  label,
  icon,
  handleRemoveItemFilter,
  disableRemoveButton = false,
  children,
  color,
}: Props) => {
  const onClickDeleteFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    handleRemoveItemFilter()
  }

  return (
    <TagStyle
      customColor={color}
      disableRemoveButton={disableRemoveButton}
      className="parentElement flex flex-row justify-between items-center gap-1"
    >
      {icon}
      {children || <span>{label}</span>}
      {!disableRemoveButton && (
        <DeleteButtonStyle
          customColor={color}
          type="button"
          onClick={onClickDeleteFilter}
          className="deleteButton"
        >
          <CrossIcon className="w-[10px] h-[10px]" />
        </DeleteButtonStyle>
      )}
    </TagStyle>
  )
}

export default GlFilterButtonV2
